/**
 * Article product cards: a short confirmation on the button after an add.
 *
 * The cards post through the theme's product-form, which updates the cart and
 * the header count and opens the cart drawer (data-open-cart-drawer), so the
 * reader sees what was added and the total. The button also confirms the add
 * for when the drawer is closed again, and a status line announces it to
 * screen readers.
 */
(function () {
  'use strict';

  const ADDED_MS = 1800;

  function init() {
    const strips = Array.from(document.querySelectorAll('[data-article-products]'));
    if (!strips.length || !window.theme || !theme.pubsub) return;

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (!event || event.source !== 'product-form' || (event.cart && event.cart.errors)) return;
      const variantId = String(event.productVariantId || '');
      if (!variantId) return;

      strips.forEach((strip) => {
        strip.querySelectorAll('form[is="product-form"]').forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          const button = form.querySelector('button[type="submit"]');
          if (input && button && input.value === variantId) showAdded(strip, button);
        });
      });
    });
  }

  function showAdded(strip, button) {
    clearTimeout(button.articleAddedTimer);
    button.classList.add('is-added');
    button.articleAddedTimer = setTimeout(() => button.classList.remove('is-added'), ADDED_MS);

    const status = strip.querySelector('[data-article-products-status]');
    if (!status) return;
    const title = button.closest('.article-product')?.querySelector('.article-product__title');
    const message = [strip.dataset.addedText, title && title.textContent.trim()].filter(Boolean).join(' – ');
    // Clear first so adding the same product twice is announced twice.
    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = message;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
